import { CoreException, Response } from '@sdk/sdk';
import { AssistantAuthorization, CliAuthorizationRequest, Organization } from '../../auth';

export abstract class AssistantDevicesRepository {
  abstract authorize(
    organization: Organization,
    request: CliAuthorizationRequest
  ): Promise<Response<AssistantAuthorization, CoreException>>;
}
